import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { handleScrollTracking } from '@utils/tracking'
import { getScrollPercent, getNewlyCrossedThresholds, SCROLL_THRESHOLDS } from '@utils/scrollDepth'

// Traccia l'evento GA4 `scroll` alle soglie 25/50/75/100% di pagina scrollata.
// Ogni soglia viene inviata una sola volta per pagina; il set viene azzerato
// ad ogni cambio rotta. Da montare una volta sola (in _app) così da coprire
// tutte le pagine, come da specifica.
export default function useScrollDepthTracking() {
  const router = useRouter()
  const firedRef = useRef<number[]>([])

  useEffect(() => {
    // reset delle soglie inviate ad ogni cambio pagina
    firedRef.current = []

    let ticking = false

    const evaluate = () => {
      ticking = false

      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const viewportHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      const percent = getScrollPercent(scrollTop, viewportHeight, documentHeight)
      const newly = getNewlyCrossedThresholds(percent, SCROLL_THRESHOLDS, firedRef.current)

      if (newly.length) {
        firedRef.current = [...firedRef.current, ...newly]
        newly.forEach((threshold) => handleScrollTracking(threshold))
      }
    }

    const handleScroll = () => {
      if (!ticking) {
        ticking = true
        window.requestAnimationFrame(evaluate)
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => window.removeEventListener('scroll', handleScroll)
  }, [router.asPath])
}
